import React from 'react';

import ErrorFallbackSvg from '../../assets/images/error-fallback.svg';


export const ErrorFallback = () => <ErrorFallbackSvg />;
